import { PostalAddressSchema } from '@app/icare/db/schema/common'
import { PatientRelation } from '@app/icare/entities/patient/schema/PatientRelation'
import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import dayjs from 'dayjs'
import { z } from 'zod'

export const PatientAddressId = entityId('patientAddress')

export type PatientAddressIdType = typeof PatientAddressId.Type

export const PatientAddressTypeEnum = defineEnum({
  delivery: msg`Lieferadresse`,
  billing: msg`Rechnungsadresse`,
})

export type PatientAddressTypeEnum = typeof PatientAddressTypeEnum.$.Type

export const PatientAddressRelationSchema = PatientRelation.extend({
  id: PatientAddressId.schema,
  type: z.enum(PatientAddressTypeEnum.$.zodEnum()),
  firstName: z.coerce.string().nullish(),
  lastName: z.coerce.string().default('').nullish(),
  addition: z.string().nullish(),
  comment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
  activeFrom: z.iso.date().default(() => dayjs().format('YYYY-MM-DD')),
})

export type PatientAddressRelation = z.infer<typeof PatientAddressRelationSchema>
